import { Checkbox } from '~/components';

export const FormCheckbox = ({
  id,
  value,
  label,
  description,
  onChange,
  disabled,
}: {
  id: string;
  value: boolean;
  label?: string;
  description?: string;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}) => {
  return (
    <div className="space-y-4">
      {label && <div>{label}</div>}

      <div className="rounded-xl border p-6">
        <div className="flex items-center space-x-3">
          <Checkbox
            checked={value}
            id={id}
            onCheckedChange={onChange}
            disabled={disabled}
          />

          {description && (
            <label
              htmlFor={id}
              className="leading-none text-muted-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              {description}
            </label>
          )}
        </div>
      </div>
    </div>
  );
};
